"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
export default function Team() {
  const teamMembers = [{
    id: 2,
    name: "Rishi Lokye",
    role: "Partner",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Rishi-New.png?v=7fw34500k38",
    bio: "Rishi joined the firm in 2005 and became a partner in 2015. He advises small and medium-sized, growing businesses, helping them identify opportunities to strengthen their financial position and support long-term expansion.\n\n\nWith significant prior experience in audit, Rishi applies a practical, analytical approach to improving reporting procedures, reducing risk, controlling costs, enhancing cash flow, increasing profitability, and minimising tax liabilities.\n\n\nRishi co-manages the firm’s Personal and Corporate Tax Department alongside Mark. He also specialises in international tax and works with a diverse portfolio of clients across the UK and overseas."
  }, {
    id: 3,
    name: "Mark Allen",
    role: "Partner",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Ma-Headshot-2.png?v=ijl7jzse51k",
    bio: "Mark has been part of our firm for over 30 years and became a partner in 2005. He works closely with small and medium-sized businesses, providing end-to-end support across tax planning, bookkeeping, and general business advice. Mark also advises on and implements tailored bookkeeping and accounting systems designed to support growth and improve efficiency. \xA0Alongside Rishi, Mark manages our personal and corporate tax department. He specialises in tax planning for small and medium-sized businesses, ensuring strategies are structured to benefit both the business and its owners."
  }, {
    id: 4,
    name: "Edward Tsui",
    role: "Consultant",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Edward.jpg?v=hoi6nebdry",
    bio: "Edward advises SMEs and overseas property investors on tax planning, structuring and compliance in the UK. He works with small and growing businesses, not‑for‑profit organisations, and the UK subsidiaries of Hong Kong and China–based companies, helping them strengthen their financial position and navigate complex regulatory requirements. His work spans mergers and acquisitions, financial due diligence, and the establishment and management of UK subsidiaries for international groups. Edward also specialises in UK residential and commercial property tax for overseas investors, as well as personal tax planning for self‑employed individuals and company directors.\n\nPrior to joining Sloane & Co, Edward was a general practice partner in a UK’s top 30 chartered accountancy firm for over 25 years."
  }];
  const smallTeamMembers = [{
    id: 101,
    name: "Elis Rashidova-Pileva",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Elis-Rashidova-Pileva.png?v=g9x1xgvclw"
  }, {
    id: 102,
    name: "Alina Macovei",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Alina-bw.jpeg?v=sdkttx65jrn"
  }, {
    id: 103,
    name: "Neeraja Thiruchittampalam",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Neeraja.jpg?v=bpeq7nsem6l"
  }, {
    id: 104,
    name: "Mariya Atanasova",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Mariya.jpg?v=18ginw3eq1"
  }, {
    id: 105,
    name: "Yana Solovii",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/yana-bw.jpg?v=btw5i3r9z8w"
  }, {
    id: 106,
    name: "Galina Arnaudova",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Galina-300x300-1.jpg?v=k22wbicwydr"
  }, {
    id: 107,
    name: "Victoria Santamaria",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/Victoria-1000x1000-1.jpg?v=ta6574y1i"
  }, {
    id: 108,
    name: "Amanda Uddin",
    image: "https://grown-elk-1.10web.cloud/wp-content/uploads/2026/02/amanda-968x968-1.jpg?v=7n22j2iczzq"
  }];
  const socialLinks = [{
    memberId: 2,
    facebook: "",
    twitter: "",
    linkedin: "https://linkedin.com",
    instagram: "https://www.instagram.com/sloanecollp/"
  }, {
    memberId: 3,
    facebook: "https://facebook.com",
    twitter: "",
    linkedin: "https://www.linkedin.com/in/mark-allen-3525367",
    instagram: "https://www.instagram.com/sloanecollp/"
  }];
  return <section id="team" className="bg-dark-section text-dark-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-[36px] leading-[1.2] font-bold tracking-[-0.2px] mb-4 !text-[hsl(210,17%,98%)] md:text-[48px]">
            Meet Our Team
          </h2>
          <p className="text-[16px] leading-[1.6] max-w-2xl mx-auto !text-[hsl(210,17%,98%)]">
            Experienced professionals dedicated to your financial success
          </p>
        </div>

        <div className="space-y-20">
          {teamMembers.map((member, i) => {
          const socials = socialLinks.find(s => s.memberId === member.id);
          return <div key={member.id} data-index={i} className="grid md:grid-cols-2 gap-12 items-center">
                <div className="order-1">
                  <SafeHydrate><Avatar className="w-full h-auto aspect-square max-w-md mx-auto rounded-full border-[1.5px] border-primary shadow-strong">
                    <AvatarImage src={member.image} alt={member.name} className="object-cover" />
                    <AvatarFallback className="text-[48px] font-bold bg-primary text-foreground-primary">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                </div>

                <div className="order-2 space-y-6">
                  <div>
                    <h3 className="text-[28px] md:text-[36px] leading-[1.3] font-semibold tracking-[-0.2px] mb-2">
                      {member.name}
                    </h3>
                    <p className="text-primary text-[18px] font-medium mb-4">
                      {member.role}
                    </p>
                    <p className="text-[16px] leading-[1.6] !text-[hsl(210,17%,98%)]">
                      {member.bio}
                    </p>
                  </div>

                  {socials && <div className="flex gap-4 items-center">
                      {socials.facebook && i !== 1 && <Link to={socials.facebook} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="Facebook">
                          <Facebook className="w-5 h-5" />
                        </Link>}
                      {socials.twitter && <Link to={socials.twitter} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="Twitter">
                          <Twitter className="w-5 h-5" />
                        </Link>}
                      {socials.linkedin && <Link to={socials.linkedin} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="LinkedIn">
                          <Linkedin className="w-5 h-5" />
                        </Link>}
                      {socials.instagram && <Link to={socials.instagram} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="Instagram">
                          <Instagram className="w-5 h-5" />
                        </Link>}
                    </div>}
                </div>
              </div>;
        })}

          <div className="pt-12 border-t border-border/20">
            <h4 className="text-center text-[22px] font-semibold mb-10 !text-[hsl(210,17%,98%)]">
              The Team
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 max-w-4xl mx-auto">
              {smallTeamMembers.map((member, i) => <div key={member.id} data-index={i} className="flex flex-col items-center gap-3">
                  <SafeHydrate><Avatar className="w-20 h-20 md:w-24 md:h-24 border-2 border-primary/20 hover:border-primary transition-colors duration-300">
                    <AvatarImage src={member.image} alt={member.name} className="object-cover" />
                    <AvatarFallback className="bg-primary/5 text-primary text-xl">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <span className="text-[14px] font-medium text-dark-foreground/70 text-center">{member.name}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}